import { useQuery, QueryHookOptions } from '@apollo/client';

import { GetMemberInfoForOffer, GetMemberInfoForOfferVariables } from '@affiliates/queries/types/GetMemberInfoForOffer';
import { GET_MEMBER_INFO_FOR_OFFER } from '../queries/getMemberInfoForOffer';

type TOptions = QueryHookOptions<GetMemberInfoForOffer, GetMemberInfoForOfferVariables>;

export const useGetMemberInfoForOffer = (options: TOptions = {}) => useQuery<GetMemberInfoForOffer>(GET_MEMBER_INFO_FOR_OFFER, options);
